module.exports = __webpack_public_path__ + "rainbow_six_slide_mobile.webp";